__turbopack_context__.v({
  "experienceSection": "MainPage-module__xh6B5q__experienceSection",
  "heroSection": "MainPage-module__xh6B5q__heroSection",
  "pageContent": "MainPage-module__xh6B5q__pageContent",
  "projectsSection": "MainPage-module__xh6B5q__projectsSection",
  "sectionCopy": "MainPage-module__xh6B5q__sectionCopy",
  "sectionEyebrow": "MainPage-module__xh6B5q__sectionEyebrow",
  "sectionInner": "MainPage-module__xh6B5q__sectionInner",
  "sectionTitle": "MainPage-module__xh6B5q__sectionTitle",
  "wrapper": "MainPage-module__xh6B5q__wrapper",
});
